import { useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { api } from '../../services/api'
import { addToCart } from '../../util/cart'

export default function () {
	const { id } = useParams()

	const history = useHistory()

	 const { data: planoAAdicionarNoCarrinho } = useQuery({
		queryKey: ['plano-para-add-to-cart'],
		queryFn: async () => {
			const plano = await api.get(`plano/${id}`)

			return plano
		}
	})

	useEffect(() => {
		if(planoAAdicionarNoCarrinho) {
			addToCart(planoAAdicionarNoCarrinho)

			history.push('/signup')
		}
	}, [planoAAdicionarNoCarrinho])
	
	return null
}
